import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16fb3530"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sdds-table sdds-table--compact sdds-table--no-min-width"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "sdds-table__header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "sdds-table__row" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell" }),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Row"),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Details")
  ])
], -1))
const _hoisted_3 = { class: "sdds-table__body" }
const _hoisted_4 = {
  class: "sdds-table__row",
  "data-test-id": "dataRowItem"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "sdds-u-pl2 sdds-u-pr2",
  "data-test-id": "rowNumber"
}
const _hoisted_10 = { class: "sdds-u-pl2 sdds-u-pr2" }
const _hoisted_11 = { class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2 sdds-details-row" }
const _hoisted_12 = {
  key: 0,
  class: "sdds-table__row",
  "data-test-id": "dataRowDetail"
}
const _hoisted_13 = {
  class: "sdds-table__body-cell",
  colspan: "4"
}
const _hoisted_14 = {
  key: 0,
  "data-test-id": "lbYntId"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "YNT Id: ", -1))
const _hoisted_16 = {
  key: 1,
  "data-test-id": "lbLeadId"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lead Id: ", -1))
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "sdds-table__footer"
}
const _hoisted_21 = { class: "sdds-table__footer-row" }
const _hoisted_22 = {
  class: "sdds-table__footer-cell",
  colspan: "4"
}
const _hoisted_23 = { class: "sdds-table__pagination" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-table__row-selector" }, null, -1))
const _hoisted_25 = { class: "sdds-table__page-selector" }
const _hoisted_26 = ["max"]
const _hoisted_27 = { class: "sdds-table__footer-text" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" pages ")
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sdds-table__footer-btn-svg",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.217 4.273a1 1 0 0 1 0 1.415l-9.888 9.888a.6.6 0 0 0 0 .848l9.888 9.888a1 1 0 0 1-1.414 1.415l-9.889-9.889a2.6 2.6 0 0 1 0-3.677l9.889-9.888a1 1 0 0 1 1.414 0Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sdds-table__footer-btn-svg",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.783 27.727a1 1 0 0 1 0-1.415l9.888-9.888a.6.6 0 0 0 0-.848L9.783 5.688a1 1 0 0 1 1.414-1.415l9.889 9.889a2.6 2.6 0 0 1 0 3.676l-9.889 9.889a1 1 0 0 1-1.414 0Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_35 = [
  _hoisted_34
]

import { PropType, ref } from 'vue';
import che_down from '../assets/chevron_down.svg';
import che_up from '../assets/chevron_up.svg';
import { FileDetailsData } from '../types/types';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FileHistoryDetails',
  props: {
  fileData: {
    type: Array as PropType<Array<FileDetailsData>>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const fileDetailsData = ref(props.fileData)

const currentPage = ref(1);
const elementsPerPage = 10;

const get_rows = () => {
  var start = (currentPage.value - 1) * elementsPerPage;
  var end = start + elementsPerPage;
  return fileDetailsData.value.slice(start, end);
}
const num_pages = () => {
  return Math.ceil(fileDetailsData.value.length / elementsPerPage);
}


return (_ctx: any,_cache: any) => {
  return (fileDetailsData.value.length > 0)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_rows(), (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("tr", _hoisted_4, [
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "sdds-btn sdds-btn-sm sdds-btn-ghost",
                    onClick: ($event: any) => (item.visible = !item.visible),
                    "data-test-id": "btviewDetails"
                  }, [
                    _createElementVNode("span", null, [
                      (!item.visible)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(che_down)
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      (item.visible)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(che_up)
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_6)
                ]),
                _createElementVNode("td", _hoisted_9, _toDisplayString(item.rowNumber), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(item.rowStatus), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(item.comments), 1)
              ]),
              (item.visible)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(item.rowData), ([subKey, value]) => {
                          return (_openBlock(), _createElementBlock("li", { key: subKey }, [
                            _createElementVNode("strong", null, _toDisplayString(subKey) + ": ", 1),
                            _createElementVNode("span", null, _toDisplayString(value), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("ul", null, [
                        (item.yntId)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("span", null, _toDisplayString(item.yntId), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.leadId)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("span", null, _toDisplayString(item.leadId), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.additionalData, (idata) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: idata.name
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(idata.name) + ": ", 1),
                            (idata.name.toLowerCase().includes('configuratorurl') || idata.name.toLowerCase().includes('previewurl'))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: idata.value
                                }, _toDisplayString(idata.value), 9, _hoisted_18))
                              : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(idata.value), 1))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        (num_pages() > 1)
          ? (_openBlock(), _createElementBlock("tfoot", _hoisted_20, [
              _createElementVNode("tr", _hoisted_21, [
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        class: "sdds-table__page-selector-input sdds-input-numberpage",
                        type: "number",
                        min: "1",
                        id: "num-page",
                        max: num_pages(),
                        pattern: "[0-9]+",
                        dir: "rtl",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event))
                      }, null, 8, _hoisted_26), [
                        [_vModelText, currentPage.value]
                      ]),
                      _createElementVNode("p", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", null, _toDisplayString(num_pages()), 1),
                        _hoisted_29
                      ]),
                      _createElementVNode("button", {
                        "data-test-id": "btPrevPage",
                        class: "sdds-table__footer-btn",
                        disabled: currentPage.value <= 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value--))
                      }, _hoisted_32, 8, _hoisted_30),
                      _createElementVNode("button", {
                        "data-test-id": "btNextPage",
                        class: "sdds-table__footer-btn",
                        disabled: currentPage.value >= num_pages(),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value++))
                      }, _hoisted_35, 8, _hoisted_33)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})